(ns core.util.schemas
  (:require [cloudpermit-commons.schemas.general :as general]
            [core.domain.validators :as v]
            [core.util.normalize :as normalize]
            [schema.core :as s]))


(def check-int (s/checker s/Int))


(def check-ints (s/checker [s/Int]))


(def Email (s/pred v/valid-email? 'email))
(def OptionalEmail (s/pred v/valid-optional-email? 'optional-email))
(def UserInputEmail (s/pred (comp v/valid-email? normalize/canonicalize-email) 'email))
(def NonBlankString general/NonBlankString)

(def check-email (s/checker Email))
